module.exports = __webpack_public_path__ + "static/media/corona-virus-pixabay-bw.4401f63b.png";